/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      if ( window.innerWidth > 1024 ) {
        gsap.registerPlugin( ScrollTrigger );

        const sections = gsap.utils.toArray( '.hc-component' );
        let maxWidth = 0;

        const getMaxWidth = () => {
          maxWidth = 0;
          sections.forEach( ( section ) => {
            maxWidth += section.offsetWidth;
          } );
        };
        getMaxWidth();
        ScrollTrigger.addEventListener( 'refreshInit', getMaxWidth );
        window.maxWidth = maxWidth;

        gsap.to( sections, {
          x: () => `-${maxWidth - window.innerWidth}`,
          ease: 'none',
          scrollTrigger: {
            trigger: '.horizontal-components',
            pin: true,
            scrub: true,
            start: 'top ' + window.navHeight,
            end: () => `+=${maxWidth}`,
            invalidateOnRefresh: true,
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'horizontal-components', COMPONENT );
} )( app );
